import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import roundReducer from './roundReducer';
import activityReducer from './activityReducer';
import alexReducer from './alexReducer';
import draggableLayoutsReducer from './draggableLayoutsReducer';
import dropZoneLayoutsReducer from './dropZoneLayoutsReducer';

const becauseThisThatReducer = combineReducers({
  sessionReducer,
  roundReducer,
  activityReducer,
  alexReducer,
  draggableLayoutsReducer,
  dropZoneLayoutsReducer,
});

export default becauseThisThatReducer;
